import { render, staticRenderFns } from "./PageCheckout.vue?vue&type=template&id=16419dee&"
import script from "./PageCheckout.js?vue&type=script&lang=js&"
export * from "./PageCheckout.js?vue&type=script&lang=js&"
import style0 from "./PageCheckout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageCheckout.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcheckout%2FPageCheckout%2FPageCheckout.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports